var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3462 3H2.65385C2.34783 3 2.05434 3.12157 1.83795 3.33795C1.62157 3.55434 1.5 3.84783 1.5 4.15385V14.5385C1.5 14.8445 1.62157 15.138 1.83795 15.3544C2.05434 15.5707 2.34783 15.6923 2.65385 15.6923H15.3462C15.6522 15.6923 15.9457 15.5707 16.162 15.3544C16.3784 15.138 16.5 14.8445 16.5 14.5385V4.15385C16.5 3.84783 16.3784 3.55434 16.162 3.33795C15.9457 3.12157 15.6522 3 15.3462 3ZM2.65385 11.0769H3.80769C3.9607 11.0769 4.10744 11.0161 4.21564 10.9079C4.32383 10.7998 4.38462 10.653 4.38462 10.5C4.38462 10.347 4.32383 10.2002 4.21564 10.0921C4.10744 9.98386 3.9607 9.92308 3.80769 9.92308H2.65385V8.76923H3.80769C3.9607 8.76923 4.10744 8.70845 4.21564 8.60025C4.32383 8.49206 4.38462 8.34532 4.38462 8.19231C4.38462 8.0393 4.32383 7.89256 4.21564 7.78436C4.10744 7.67617 3.9607 7.61538 3.80769 7.61538H2.65385V6.46154H3.80769C3.9607 6.46154 4.10744 6.40076 4.21564 6.29256C4.32383 6.18437 4.38462 6.03762 4.38462 5.88462C4.38462 5.73161 4.32383 5.58486 4.21564 5.47667C4.10744 5.36848 3.9607 5.30769 3.80769 5.30769H2.65385V4.15385H5.53846V14.5385H2.65385V11.0769ZM15.3462 14.5385H6.69231V4.15385H15.3462V14.5385Z",
    fill: "white",
    fillOpacity: 0.74
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosites);
export default __webpack_public_path__ + "static/media/microsites.620a29e2f30dfcf58b3efca91838dcc5.svg";
export { ForwardRef as ReactComponent };